import React, { useEffect } from "react";
import Header from "../Layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { allapiAction } from "../../Redux/common/action";
import PackageLsit from "./PackageLsit";

function Stake() {
  const dispatch = useDispatch();
  const router = useNavigate();

  const locationv = useLocation();

  const searchParams = new URLSearchParams(locationv.search);
  const search = searchParams.get("search");
  const location = searchParams.get("location");
  const page = searchParams.get("page");

  const get_product_list = useSelector((state) =>
    state?.allapi?.user_product_search ? state?.allapi?.user_product_search : {}
  );

  const pageno = page ? page : 1;
  const listdata = get_product_list?.docs ? get_product_list?.docs : [];

  useEffect(() => {
    // searchProduct

    if (search) {
      if (location) {
        dispatch(
          allapiAction.userSearchProduct({ page: pageno, id: search, location })
        );
      } else {
        dispatch(allapiAction.userSearchProduct({ page: pageno, id: search }));
      }
    } else {
      if (location) {
        dispatch(allapiAction.userSearchProduct({ page: pageno, location }));
      } else {
        dispatch(allapiAction.userSearchProduct({ page: pageno }));
      }
    }
    // dispatch(allapiAction.getfiltercategory({}));
    return () => {};
  }, [locationv.search]);

  const orderSumit = (e) => {
    // createOrder

    // if (PaymentMethod == "online") {
    //   displayRazorpay();
    // } else {

    // const orderAddress = localStorage.getItem("order_Address");

    // console.log(orderAddress);
    // const obj = JSON.parse(orderAddress);
    // console.log(obj);

    dispatch(
      allapiAction.createOrder(
        {
          packageId: e?._id,
          amount: e?.price,
          // user_email: get_user_profile?.email,
          // user_mobile: get_user_profile?.phone,
          // delivery_charges: "0",
          // sub_total: totalSubtotalPrice,
          // address_id: obj,
          payment_mode_name: "wallet",
          // products_ids: commentsData,
        },
        router
      )
    );
    return () => {};
    // }
  };

  return (
    <div>
      <Header />

      <div className="stake">
        <div class="container-fluid mt-5 mb-5 pb-5">
          <div class="row pt-4 mb-5">
            {/* <div class="nav-tabs-wrapper">
              <ul
                class="nav nav-tabs flex-nowrap"
                id="categoryTabs"
                role="tablist"
              >
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active  text-dark text-nowrap"
                    id="women-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#women"
                    type="button"
                    role="tab"
                    aria-controls="women"
                    aria-selected="true"
                  >
                    Stake
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link text-dark text-nowrap"
                    id="men-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#men"
                    type="button"
                    role="tab"
                    aria-controls="men"
                    aria-selected="false"
                  >
                    Polygon NFT
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link text-dark text-nowrap"
                    id="kids-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#kids"
                    type="button"
                    role="tab"
                    aria-controls="kids"
                    aria-selected="false"
                  >
                    Art
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link text-dark text-nowrap"
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home"
                    type="button"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    Collectibles
                  </button>
                </li>
              </ul>
            </div> */}

            <div class="tab-content mt-3" id="categoryTabsContent">
              {/* <!-- Stake --> */}
              <div
                class="tab-pane fade show active"
                id="women"
                role="tabpanel"
                aria-labelledby="women-tab"
              >
                {/* <!-- Sub Tabs --> */}
                <ul
                  class="nav nav-tabs d-flex justify-content-center"
                  id="subCategoryTabs"
                  role="tablist"
                >
                  <li class="nav-item">
                    <button
                      class="nav-link active text-dark text-nowrap"
                      id="stake-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#stake"
                      type="button"
                      role="tab"
                      aria-controls="stake"
                      aria-selected="true"
                    >
                      Package
                    </button>
                  </li>
                  {/* <li class="nav-item">
                    <button
                      class="nav-link text-dark text-nowrap"
                      id="collection-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#collection"
                      type="button"
                      role="tab"
                      aria-controls="collection"
                      aria-selected="false"
                    >
                      Collection
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      class="nav-link text-dark text-nowrap"
                      id="my-stake-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#my-stake"
                      type="button"
                      role="tab"
                      aria-controls="my-stake"
                      aria-selected="false"
                    >
                      My Stake
                    </button>
                  </li> */}
                </ul>

                {/* <!-- Sub Tabs Content --> */}
                <div
                  class="tab-content bg-light mt-3 shadow-sm"
                  id="subCategoryTabsContent"
                >
                  {/* <!-- Stake Tab --> */}
                  <div
                    class="tab-pane fade show active"
                    id="stake"
                    role="tabpanel"
                    aria-labelledby="stake-tab"
                  >
                    {/* <ul
                      class="nav nav-pills d-flex justify-content-between"
                      id="gameTabs"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <button
                          class="nav-link  text-center border"
                          id="staking-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#staking"
                          type="button"
                          role="tab"
                          aria-controls="staking"
                          aria-selected="true"
                        >
                          Exclusive Zone
                        </button>
                      </li>
                      <li class="nav-item">
                        <button
                          class="nav-link text-center border"
                          id="nft-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nft"
                          type="button"
                          role="tab"
                          aria-controls="nft"
                          aria-selected="false"
                        >
                          Free Zone
                        </button>
                      </li>
                    </ul> */}

                    <div class="tab-content mt-3" id="gameTabsContent">
                      <div
                        class="tab-pane fade show active"
                        id="staking"
                        role="tabpanel"
                        aria-labelledby="staking-tab"
                      >
                        <PackageLsit />
                        {/* 
                        <div class="col-12 stake-card border my-3">
                          <div class="card-header">
                            <h5>
                            
                              <small>Exclusive Stake 1 </small>
                              <a href="">
                                <img
                                  class="tlogo-img-position"
                                  src="img/icons8-help-18.png"
                                  alt=""
                                />
                              </a>
                            </h5>
                            <h5 class="badge-level">
                              <small>LV2 - LV6</small>
                            </h5>
                          </div>
                          <img
                            src="img/game banner a.png"
                            class="banner my-2"
                            alt="NFT Exclusive Zone"
                          />

                          <div>
                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Status</small>
                              </p>
                              <p>
                                {" "}
                                <small class="status-open">Open</small>
                              </p>
                            </div>

                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Price Range:</small>
                              </p>
                              <p class="">
                                <small>
                                  <img
                                    class="tlogo-img-position"
                                    src="img/t logo.png"
                                    alt=""
                                  />
                                  199 - 1,000
                                </small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Income:</small>
                              </p>
                              <p class="">
                                <small>1.5%</small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Handling Fee: </small>
                              </p>
                              <p>1%</p>
                            </div>
                          </div>
                          <button class="btn-stake">Go to stake</button>
                        </div>
                  
                        <div class="col-12 stake-card border my-3">
                          <div class="card-header">
                            <h5>
                              {" "}
                              <small>Exclusive Stake 1 </small>
                              <a href="">
                                <img
                                  class="tlogo-img-position"
                                  src="img/icons8-help-18.png"
                                  alt=""
                                />
                              </a>
                            </h5>
                            <h5 class="badge-level">
                              <small>LV2 - LV6</small>
                            </h5>
                          </div>
                          <img
                            src="img/game banner a.png"
                            class="banner my-2"
                            alt="NFT Exclusive Zone"
                          />

                          <div>
                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Status</small>
                              </p>
                              <p>
                                {" "}
                                <small class="status-open">Open</small>
                              </p>
                            </div>

                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Price Range:</small>
                              </p>
                              <p class="">
                                <small>
                                  <img
                                    class="tlogo-img-position"
                                    src="img/t logo.png"
                                    alt=""
                                  />
                                  199 - 1,000
                                </small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Income:</small>
                              </p>
                              <p class="">
                                <small>1.5%</small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Handling Fee: </small>
                              </p>
                              <p>1%</p>
                            </div>
                          </div>
                          <button class="btn-stake">Go to stake</button>
                        </div>
                        
                        <div class="col-12 stake-card border my-3">
                          <div class="card-header">
                            <h5>
                              {" "}
                              <small>Exclusive Stake 1 </small>
                              <a href="">
                                <img
                                  class="tlogo-img-position"
                                  src="img/icons8-help-18.png"
                                  alt=""
                                />
                              </a>
                            </h5>
                            <h5 class="badge-level">
                              <small>LV2 - LV6</small>
                            </h5>
                          </div>
                          <img
                            src="img/game banner a.png"
                            class="banner my-2"
                            alt="NFT Exclusive Zone"
                          />

                          <div>
                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Status</small>
                              </p>
                              <p>
                                {" "}
                                <small class="status-open">Open</small>
                              </p>
                            </div>

                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Price Range:</small>
                              </p>
                              <p class="">
                                <small>
                                  <img
                                    class="tlogo-img-position"
                                    src="img/t logo.png"
                                    alt=""
                                  />
                                  199 - 1,000
                                </small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Income:</small>
                              </p>
                              <p class="">
                                <small>1.5%</small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Handling Fee: </small>
                              </p>
                              <p>1%</p>
                            </div>
                          </div>
                          <button class="btn-stake">Go to stake</button>
                        </div>
                        
                        <div class="col-12 stake-card border my-3">
                          <div class="card-header">
                            <h5>
                              {" "}
                              <small>Exclusive Stake 1 </small>
                              <a href="">
                                <img
                                  class="tlogo-img-position"
                                  src="img/icons8-help-18.png"
                                  alt=""
                                />
                              </a>
                            </h5>
                            <h5 class="badge-level">
                              <small>LV2 - LV6</small>
                            </h5>
                          </div>
                          <img
                            src="img/game banner a.png"
                            class="banner my-2"
                            alt="NFT Exclusive Zone"
                          />

                          <div>
                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Status</small>
                              </p>
                              <p>
                                {" "}
                                <small class="status-open">Open</small>
                              </p>
                            </div>

                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Price Range:</small>
                              </p>
                              <p class="">
                                <small>
                                  <img
                                    class="tlogo-img-position"
                                    src="img/t logo.png"
                                    alt=""
                                  />
                                  199 - 1,000
                                </small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Income:</small>
                              </p>
                              <p class="">
                                <small>1.5%</small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Handling Fee: </small>
                              </p>
                              <p>1%</p>
                            </div>
                          </div>
                          <button class="btn-stake">Go to stake</button>
                        </div>
                      
                        <div class="col-12 stake-card border my-3">
                          <div class="card-header">
                            <h5>
                              {" "}
                              <small>Exclusive Stake 1 </small>
                              <a href="">
                                <img
                                  class="tlogo-img-position"
                                  src="img/icons8-help-18.png"
                                  alt=""
                                />
                              </a>
                            </h5>
                            <h5 class="badge-level">
                              <small>LV2 - LV6</small>
                            </h5>
                          </div>
                          <img
                            src="img/game banner a.png"
                            class="banner my-2"
                            alt="NFT Exclusive Zone"
                          />

                          <div>
                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Status</small>
                              </p>
                              <p>
                                {" "}
                                <small class="status-open">Open</small>
                              </p>
                            </div>

                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Price Range:</small>
                              </p>
                              <p class="">
                                <small>
                                  <img
                                    class="tlogo-img-position"
                                    src="img/t logo.png"
                                    alt=""
                                  />
                                  199 - 1,000
                                </small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Income:</small>
                              </p>
                              <p class="">
                                <small>1.5%</small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Handling Fee: </small>
                              </p>
                              <p>1%</p>
                            </div>
                          </div>
                          <button class="btn-stake">Go to stake</button>
                        </div>
                        
                        <div class="col-12 stake-card border my-3">
                          <div class="card-header">
                            <h5>
                              {" "}
                              <small>Exclusive Stake 1 </small>
                              <a href="">
                                <img
                                  class="tlogo-img-position"
                                  src="img/icons8-help-18.png"
                                  alt=""
                                />
                              </a>
                            </h5>
                            <h5 class="badge-level">
                              <small>LV2 - LV6</small>
                            </h5>
                          </div>
                          <img
                            src="img/game banner a.png"
                            class="banner my-2"
                            alt="NFT Exclusive Zone"
                          />

                          <div>
                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Status</small>
                              </p>
                              <p>
                                {" "}
                                <small class="status-open">Open</small>
                              </p>
                            </div>

                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Price Range:</small>
                              </p>
                              <p class="">
                                <small>
                                  <img
                                    class="tlogo-img-position"
                                    src="img/t logo.png"
                                    alt=""
                                  />
                                  199 - 1,000
                                </small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Income:</small>
                              </p>
                              <p class="">
                                <small>1.5%</small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Handling Fee: </small>
                              </p>
                              <p>1%</p>
                            </div>
                          </div>
                          <button class="btn-stake">Go to stake</button>
                        </div>
                        */}
                      </div>

                      <div
                        class="tab-pane fade"
                        id="nft"
                        role="tabpanel"
                        aria-labelledby="nft-tab"
                      >
                        {/* <!-- card-1 --> */}
                        <div class="col-12 stake-card border my-3">
                          <div class="card-header">
                            <h5>
                              {" "}
                              <small>Exclusive Stake 1 </small>
                              <a href="">
                                <img
                                  class="tlogo-img-position"
                                  src="img/icons8-help-18.png"
                                  alt=""
                                />
                              </a>
                            </h5>
                            <h5 class="badge-level">
                              <small>LV2 - LV6</small>
                            </h5>
                          </div>
                          <img
                            src="img/game banner a.png"
                            class="banner my-2"
                            alt="NFT Exclusive Zone"
                          />

                          <div>
                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Status</small>
                              </p>
                              <p>
                                {" "}
                                <small class="status-open">Open</small>
                              </p>
                            </div>

                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Price Range:</small>
                              </p>
                              <p class="">
                                <small>
                                  <img
                                    class="tlogo-img-position"
                                    src="img/t logo.png"
                                    alt=""
                                  />
                                  199 - 1,000
                                </small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Income:</small>
                              </p>
                              <p class="">
                                <small>1.5%</small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Handling Fee: </small>
                              </p>
                              <p>1%</p>
                            </div>
                          </div>
                          <button class="btn-stake">Go to Package</button>
                        </div>
                        {/* <!-- card-1 -->

                                    <!-- card-2 --> */}
                        <div class="col-12 stake-card border my-3">
                          <div class="card-header">
                            <h5>
                              {" "}
                              <small>Exclusive Stake 1 </small>
                              <a href="">
                                <img
                                  class="tlogo-img-position"
                                  src="img/icons8-help-18.png"
                                  alt=""
                                />
                              </a>
                            </h5>
                            <h5 class="badge-level">
                              <small>LV2 - LV6</small>
                            </h5>
                          </div>
                          <img
                            src="img/game banner a.png"
                            class="banner my-2"
                            alt="NFT Exclusive Zone"
                          />

                          <div>
                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Status</small>
                              </p>
                              <p>
                                {" "}
                                <small class="status-open">Open</small>
                              </p>
                            </div>

                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Price Range:</small>
                              </p>
                              <p class="">
                                <small>
                                  <img
                                    class="tlogo-img-position"
                                    src="img/t logo.png"
                                    alt=""
                                  />
                                  199 - 1,000
                                </small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Income:</small>
                              </p>
                              <p class="">
                                <small>1.5%</small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Handling Fee: </small>
                              </p>
                              <p>1%</p>
                            </div>
                          </div>
                          <button class="btn-stake">Go to Package</button>
                        </div>
                        {/* <!-- card-2 -->

                                    <!-- card-3 --> */}
                        <div class="col-12 stake-card border my-3">
                          <div class="card-header">
                            <h5>
                              {" "}
                              <small>Exclusive Stake 1 </small>
                              <a href="">
                                <img
                                  class="tlogo-img-position"
                                  src="img/icons8-help-18.png"
                                  alt=""
                                />
                              </a>
                            </h5>
                            <h5 class="badge-level">
                              <small>LV2 - LV6</small>
                            </h5>
                          </div>
                          <img
                            src="img/game banner a.png"
                            class="banner my-2"
                            alt="NFT Exclusive Zone"
                          />

                          <div>
                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Status</small>
                              </p>
                              <p>
                                {" "}
                                <small class="status-open">Open</small>
                              </p>
                            </div>

                            <div class="d-flex justify-content-between">
                              <p>
                                <small class="text-muted">Price Range:</small>
                              </p>
                              <p class="">
                                <small>
                                  <img
                                    class="tlogo-img-position"
                                    src="img/t logo.png"
                                    alt=""
                                  />
                                  199 - 1,000
                                </small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Income:</small>
                              </p>
                              <p class="">
                                <small>1.5%</small>
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Handling Fee: </small>
                              </p>
                              <p>1%</p>
                            </div>
                          </div>
                          <button class="btn-stake">Go to Package </button>
                        </div>
                        {/* <!-- card-3 --> */}
                      </div>
                    </div>
                  </div>

                  {/* <!-- Collection Tab --> */}
                  <div
                    class="tab-pane fade"
                    id="collection"
                    role="tabpanel"
                    aria-labelledby="collection-tab"
                  >
                    <div class="no-data text-center">
                      <img
                        class="w-50"
                        src="https://cdn-icons-png.flaticon.com/512/4076/4076432.png"
                        alt="No Data"
                      />
                      <h5>No Data Available</h5>
                      <p>(GMT+05:30) 2025/03/02 16:37:35</p>
                    </div>
                  </div>

                  {/* <!-- My Stake Tab --> */}
                  <div
                    class="tab-pane fade"
                    id="my-stake"
                    role="tabpanel"
                    aria-labelledby="my-stake-tab"
                  >
                    <div class="row mt-4">
                      <div class="col-6">
                        <div class="card p-1 shadow-sm main-1-border2">
                          <h6>
                            <small>Total Stake Value</small>
                          </h6>
                          <h4 class="fw-bold">
                            <small class="main-usdt-color">0 </small>
                          </h4>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card p-1 shadow-sm main-1-border">
                          <h6>
                            <small>Total Stake Income</small>
                          </h6>
                          <h4 class="fw-bold">
                            <small class="main-usdt-color">0</small>
                          </h4>
                        </div>
                      </div>
                      <div class="mt-5">
                        <div class="no-data text-center">
                          <img
                            class="w-50"
                            src="https://cdn-icons-png.flaticon.com/512/4076/4076432.png"
                            alt="No Data"
                          />
                          <h5>No Data Available</h5>
                          <p>(GMT+05:30) 2025/03/02 16:37:35</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Polygon NFT --> */}
              <div
                class="tab-pane fade"
                id="men"
                role="tabpanel"
                aria-labelledby="men-tab"
              >
                <div class="row text-dark">
                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player a.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_174061</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player b.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_17857</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 </small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player c.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_449737</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player d.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_596274</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player e.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_200676</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player f.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_196687</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player g.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_718584</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player h.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_478831</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Art --> */}
              <div
                class="tab-pane fade"
                id="kids"
                role="tabpanel"
                aria-labelledby="kids-tab"
              >
                <div class="row text-dark">
                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player a.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_174061</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player b.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_17857</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player c.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_449737</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player d.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_596274</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player e.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_200676</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player f.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_196687</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player g.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_718584</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player h.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_478831</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Collectibles --> */}
              <div
                class="tab-pane fade"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <div class="row text-dark">
                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player a.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_174061</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player b.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_17857</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player c.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_449737</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player d.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_596274</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player e.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_200676</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player f.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_196687</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player g.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_718584</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 my-3">
                    <div class="card border border-4 border-light rounded-4 bg-white p-2">
                      <img
                        class="w-100 rounded-4"
                        src="img/player h.png"
                        alt=""
                      />
                      <div class="card-body p-0 mt-3">
                        <h6 class="fw-bold text-center">Stake_478831</h6>
                        <div class="d-flex main-11-tlogo gap-1 justify-content-center">
                          <div>
                            <img src="img/t logo.png" alt="" />
                          </div>
                          <h6 class="mt-1 fw-bold">
                            <small>309 USDT</small>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: "100px" }}></div>
    </div>
  );
}

export default Stake;
